var link_viewer_default = {
  "fontElementMap": "sYSpH",
  "link": "l-goH",
  "linkInEditor": "En49l",
  "linkInViewer": "_4688G",
  "toolbarUrlContainer": "qgcUt",
  "toolbarUrl": "-ksnJ",
  "toolbarUrlAnchor": "j8AV9"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
